/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type EnsureManagedAssistantSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type EnsureManagedAssistantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type EnsureManagedAssistantSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const EnsureManagedAssistantSecurity$outboundSchema: z.ZodMiniType<
  EnsureManagedAssistantSecurity$Outbound,
  EnsureManagedAssistantSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function ensureManagedAssistantSecurityToJSON(
  ensureManagedAssistantSecurity: EnsureManagedAssistantSecurity,
): string {
  return JSON.stringify(
    EnsureManagedAssistantSecurity$outboundSchema.parse(
      ensureManagedAssistantSecurity,
    ),
  );
}

/** @internal */
export type EnsureManagedAssistantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const EnsureManagedAssistantRequest$outboundSchema: z.ZodMiniType<
  EnsureManagedAssistantRequest$Outbound,
  EnsureManagedAssistantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function ensureManagedAssistantRequestToJSON(
  ensureManagedAssistantRequest: EnsureManagedAssistantRequest,
): string {
  return JSON.stringify(
    EnsureManagedAssistantRequest$outboundSchema.parse(
      ensureManagedAssistantRequest,
    ),
  );
}
